import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { reduxActionTypePrefix, reduxKeys } from "../constants/constants.js";
import MessagesResource from "../resources/Messages.resource.js";
const actionTypesPrefix = reduxActionTypePrefix + "/loadMessageCount";
const messageCountLoadEpicReducerArg = {
  actionPrefix: actionTypesPrefix,
  reduxKeyNested: () => [reduxKeys.value],
  loadResource: (request) => MessagesResource.getMessagesCount(request.workspaceId, request.lastMessageId),
  onCompleteSuccess: (resourcesResult, inputPayload) => resourcesResult == null ? void 0 : resourcesResult.Value
};
const messageCountLoadEpicReducer = loadResourcesUtils(messageCountLoadEpicReducerArg);
const messageCountReducerStateDefault = {
  value: getDefaultAsyncWrapperObj()
};
const messageCountReducer = (state = messageCountReducerStateDefault, action) => {
  state = messageCountLoadEpicReducer.reduxChange(state, action);
  return state;
};
export {
  messageCountReducer as default,
  messageCountLoadEpicReducer,
  messageCountReducer,
  messageCountReducerStateDefault
};
//# sourceMappingURL=messageCount.duck.js.map
